import { render, staticRenderFns } from "./SportRecord.vue?vue&type=template&id=15d74e20&scoped=true"
import script from "./SportRecord.vue?vue&type=script&lang=js"
export * from "./SportRecord.vue?vue&type=script&lang=js"
import style0 from "./SportRecord.vue?vue&type=style&index=0&id=15d74e20&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d74e20",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15d74e20')) {
      api.createRecord('15d74e20', component.options)
    } else {
      api.reload('15d74e20', component.options)
    }
    module.hot.accept("./SportRecord.vue?vue&type=template&id=15d74e20&scoped=true", function () {
      api.rerender('15d74e20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sportCenter/components/athetes/trainingData/SportRecord.vue"
export default component.exports